import { useCallback, useState } from "react";
import useMerchantPortalAxios from "../utils/axios";

const useBillsAPI = () => {
  const MerchantPortalAxios = useMerchantPortalAxios();

  const [totalNbOfPage, setTotalNbOfPage] = useState(1);
  const [totalCount, setTotalCount] = useState(0);
  const [TransactionBills, setTransactionBills] = useState([]);
  const [IsAutomatable, setIsAutomatable] = useState(false);

  const [billsLoading, setBillsLoading] = useState(true);

  const GetAllBills = useCallback(async () => {
    const res = await MerchantPortalAxios.post(`/v1/Bills/GetAllBills`, {
      SessionID: sessionStorage.getItem("SessionID"),
    });
    return res?.data?.Payload;
  }, [MerchantPortalAxios]);

  const GetBillTransactionHistory = useCallback(
    async (pageNb, dateFrom, DateTo, getUtilityId) => {
      setBillsLoading(true);
      await MerchantPortalAxios.post(`/v1/Bills/GetBillTransactionHistory`, {
        SessionID: sessionStorage.getItem("SessionID"),
        page: pageNb,
        pageSize: 10,
        DateFrom: dateFrom,
        DateTo: DateTo,
        UtilityID: getUtilityId,
      })
        .then((res) => {
          setTransactionBills(res.data.Payload.BillsTransactions);
          setIsAutomatable(res.data.Payload.IsAutomatable);
          if (res.data.Payload?.BillsTransactions?.length === 0) {
            setTotalNbOfPage(0);
            setTotalCount(0);
          } else {
            setTotalNbOfPage(res.data.Payload.BillsTransactions[0].TotalPages);
            setTotalCount(res.data.Payload.BillsTransactions[0].TotalCount);
          }
        })
        .finally(() => {
          setBillsLoading(false);
        });
    },
    [MerchantPortalAxios],
  );

  const UpdateAutomaticBillPayment = useCallback(async (payload) => {
      const response = await MerchantPortalAxios.post(
        `/v1/Bills/UpdateAutomaticBillPayment`,
        payload,
      );
      return response.data.Payload;
  }, [MerchantPortalAxios]);

  return {
    GetAllBills,
    GetBillTransactionHistory,
    TransactionBills,
    IsAutomatable,
    totalCount,
    totalNbOfPage,
    billsLoading,
    UpdateAutomaticBillPayment
  };
};

export default useBillsAPI;
